export const imgUrl = process.env.REACT_APP_APPLICATION_MOOD === "production" 
  ? process.env.REACT_APP_BACKEND_URL_PRODUCTION 
  : 'https://we-prop-backend.onrender.com/';

// export const logo = '/assets/icons/MyMalkiyet.png'
export const logo = "/assets/icons/jagiir.com-logo.png"
// export const logo = "/assets/icons/v3.png"
// export const name = 'Malkiyet'
export const name = 'Jagiir'
// export const name = 'We Prop'